module.exports = __webpack_public_path__ + "static/cusick-d8a2d8d4c72bed234996885ef26e00fc.jpg";